module.exports = __webpack_public_path__ + "images/emoji/confounded.2df9756e5d360a391cf9.png";